<template>
	<div>
		<skeleton-loading v-if="requestCalls > 0"></skeleton-loading>

		<div v-else>
			<div class="row">
	            <div class="col-6">
	              <h3>{{ tt("mcr_information") }}</h3>
	            </div>
	            <div v-if="(formType == 'edit' || formType == 'approval') && authUserPermission['mcr-approval-edit-header']" class="col-6 text-right">
	              <base-button
	                size="sm"
	                type="default"
	                @click="editMcrInformation"
	                >{{ tt("edit") }}</base-button
	              >
	            </div>
	        </div>
	        <div class="row">
	            <div class="col-12">
					<div class="alert alert-primary" role="alert" v-if="mcrType == 'A1S'">
						<strong>Peringatan!</strong> Harap klik <strong>Save</strong> terlebih dahulu sebelum memasukkan data SHP.
					</div>
	              <table class="table table-responsive-md table-bordered">
	                <tbody>
	                  <tr>
	                    <th class="bg-secondary">{{ tt("subject") }}</th>
	                    <td colspan="3">{{ mcrInformation.subject }}</td>
	                  </tr>
					  <tr>
	                  	<th class="bg-secondary">{{ tt("status") }}</th>
	                    <td colspan="3">{{ mcrInformation.status }}</td>
	                  </tr>
					  <tr>
	                  	<th class="bg-secondary">{{ tt("priority_level") }}</th>
	                    <td colspan="3">
							<label class="badge badge-success" v-if="mcrInformation.priority_level == 1">{{ mcrInformation.priority_level_desc }}</label>
							<label class="badge badge-warning" v-else-if="mcrInformation.priority_level == 2">{{ mcrInformation.priority_level_desc }}</label>
							<label class="badge badge-danger" v-else-if="mcrInformation.priority_level == 3">{{ mcrInformation.priority_level_desc }}</label>
						</td>
	                  </tr>
	                  <tr>
	                    <th class="bg-secondary">{{ tt("type") }}</th>
	                    <td>{{ mcrInformation.form_description }}</td>
	                    <th class="bg-secondary">{{ tt("mcr_number") }}</th>
	                    <td>{{ mcrInformation.mcr_number }}</td>
	                  </tr>
	                  <tr>
	                    <th class="bg-secondary">{{ tt("created_by") }}</th>
	                    <td>{{ mcrInformation.name }}</td>
						<th class="bg-secondary">{{ tt("created_at") }}</th>
	                    <td>{{ format_date(mcrInformation.created_at) }}</td>
	                  </tr>
					  <tr v-if="mcrInformation.mcr_type">
	                    <th class="bg-secondary">{{ tt("mcr_type") }}</th>
	                    <td colspan="3">{{ tt(mcrInformation.mcr_type) }}</td>
	                  </tr>
	                </tbody>
	              </table>
	            </div>
	        </div>
		</div>

        <!-- MODAL CHANGE SUBJECT -->
        <validation-observer v-slot="{ invalid }">
	      <modal :show.sync="formMcrInformation.show">
	        <template slot="header">
	          <h5 class="modal-title">{{ tt("edit_subject") }}</h5>
	        </template>
	        <div>
	            <label class="form-control-label">{{ tt("subject") }} <span class="text-danger">*</span></label>
				<base-input
					:name="tt('subject')"
					:placeholder="tt('subject')"
					v-model="mcrInformationEdit.new_subject"
					rules="required"> 	
	            </base-input>

				<label class="form-control-label">{{ tt('priority_level') }} <span class="text-danger">*</span></label>
				<base-input :name="tt('priority_level')" rules="required">
					<el-select class="select-danger" v-model="mcrInformationEdit.priority_level" :placeholder="tt('choose_priority_level')" filterable>
						<el-option class="select-danger" :value="mf['priority_level']" :label="mf['priority_level_desc']" :key="mf['priority_level']" v-for="mf in priorityLevelList"></el-option>
					</el-select>
				</base-input>

				<label class="form-control-label" v-if="[
					'MCR01',
					'MCR05',
					'MCR10',
					'MCR15',
					'MCR19',
					'MCR20',
					'MCR21',
					'MCR22',
					'MCR23',
					'MCR30'
					].includes(mcrInformation.type)">
						{{ tt("mcr_type") }} <span class="text-danger" v-if="['MCR20', 'MCR21', 'MCR22', 'MCR23'].includes(mcrInformation.type)">*</span>
				</label>
				<base-input
					v-if="[
					'MCR01',
					'MCR05',
					'MCR10',
					'MCR15',
					'MCR19',
					'MCR20',
					'MCR21',
					'MCR22',
					'MCR23',
					'MCR30'
					].includes(mcrInformation.type)"
					:name="tt('mcr_type')"
					:rules="['MCR20', 'MCR21', 'MCR22', 'MCR23'].includes(mcrInformation.type) ? 'required' : ''"
				>
					<el-select
						class="select-danger"
						v-model="mcrInformationEdit.mcr_type"
						:placeholder="tt('choose_mcr_type')"
					>
						<el-option class="select-danger" value="consumable" label="Consumable"></el-option>
						<el-option class="select-danger" value="suku_cadang" label="Suku Cadang"></el-option>
						<el-option class="select-danger" value="suku_cadang_penyangga" label="SCP (Suku Cadang Penyangga)"></el-option>
						<el-option class="select-danger" value="barang_umum_non_suku_cadang" label="Barang Umum / Non Suku Cadang"></el-option>
						<!-- <el-option class="select-danger" value="not_applicable" label="N/A (Not Applicable)"></el-option> -->
					</el-select>
				</base-input>
	        </div>
	        <template slot="footer">
	          <base-button
	            type="secondary"
	            @click="formMcrInformation.show = false"
	            >{{ tt("close") }}</base-button>
	          <base-button
	            type="primary"
	            v-on:click="updateMcrInformation"
	            :disabled="btnUpdate.onLoading || invalid">
	            <span v-if="btnUpdate.onLoading"><i class="fas fa-spinner fa-spin"></i>{{ tt("please_wait") }}</span>
	            <span v-else>{{ tt("update") }}</span>
	          </base-button>
	        </template>
	      </modal>
	    </validation-observer>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	import Api from "@/helpers/api";
	import draftList from "@/services/material/draftList.service";
	import catalogType from '@/services/master/catalogType.service';
	var moment = require('moment');

	export default {
		name: 'McrHeader',
		data() {
			return {
				moment:moment,
				requestCalls: 0,
				mcrInformation: {},
				formMcrInformation: {
			        show: false
			    },
			    mcrInformationEdit: {
			        new_subject: "",
					new_catalog_type: "",
					priority_level: "",
					mcr_type: ""
			    },
			    btnUpdate: {
			        onLoading: false
			    },
				catalogType: {},

				mcr_code: this.$route.params.mcr_code,
				token: this.$route.params.token,
				formType: this.$route.params.type,
				mcrType: this.$route.params.mcr_type
			}
		},
		computed: {
            ...mapState({
                authUserPermission :state => state.auth.userPermission,
            }),
        },
		mounted() {
			this.get();
			this.getCatalogType();
            this.getPriorityLevelList()
		},
		methods: {
			get() {
				this.requestCalls++;

				let context = this;
				Api(context, draftList.getMcrHeader(context.mcr_code, context.token))
		        .onSuccess(function(response) {
					context.mcrInformation = response.data.data[0];
					context.mcrInformationEdit.new_subject = response.data.data[0].subject;
					context.mcrInformationEdit.new_catalog_type = response.data.data[0].catalog_type_code;
					context.mcrInformationEdit.priority_level = response.data.data[0].priority_level;
					context.mcrInformationEdit.mcr_type = response.data.data[0].mcr_type;
					context.$emit('emitHeader', context.mcrInformation)
		        })
		        .onFinish(function() {
		        	context.requestCalls--;
		        })
		        .call();
		    },
			getPriorityLevelList() {
                let context = this;               
                Api(context, draftList.get_priority_level_List()).onSuccess(function(response) {    
                    context.priorityLevelList = response.data.data;
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.priorityLevelList = [];
                    }
                })
                .call()
            },
		    editMcrInformation() {
			  this.formMcrInformation.add = false;
			  this.formMcrInformation.show = true;
			},
			updateMcrInformation() {
			  let context = this;
			  // context.errorMessage = null;
			  context.btnUpdate.onLoading = true;
			  Api(
			    context,
			    draftList.updateMcrSubject(context.mcrInformation.mcr_code, context.mcrInformation.token, context.mcrInformationEdit
			    )
			  )
			    .onSuccess(function(response) {
			      context.mcrInformation.subject = context.mcrInformationEdit.new_subject;
				  context.mcrInformation.catalog_type_code = context.mcrInformationEdit.new_catalog_type;
			      context.$notify({
			        message: response.data.message,
			        type: "success",
			        verticalAlign: "bottom",
			        horizontalAlign: "left"
			      });
				  context.get()
			    })
			    .onFinish(function() {
			      context.btnUpdate.onLoading = false;
			      context.formMcrInformation.show = false;
			    })
			    .call();
			},
			format_date(value){
                if (value) {
                   return moment(String(value)).locale('id').format('LLL')
                }
            },
			getCatalogType() {
                let context = this;               
                Api(context, catalogType.getByCompany()).onSuccess(function(response) {
                    context.catalogType = response.data.data;
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.catalogType = [];
                    }
                })
                .call()
            },
		}
	};
</script>